import { ProductionLine } from '../../../production/models/enums/production-line';
import { JsonProperty } from '../../../models/utilities/json-property';

/**
 * A production week, which runs from a Wednesday to the Tuesday after
 */
export class ProductionWeek {

    @JsonProperty({ toType: 'date' })
    public start : Date = new Date();

    @JsonProperty({ toType: 'date' })
    public end : Date = new Date();

}

/**
 * The singlewides still to be produced on one line that assembles sections
 */
export class SinglewideLine {

    public productionLine : ProductionLine = ProductionLine.Unknown;

    // Singlewides whose production week has gone by and that are not produced
    public pastDue : number = 0;

    // Singlewides to produce in each of the production weeks, in the order of the weeks
    @JsonProperty({ designType: 'array' })
    public singles : number[] = [];

}

/**
 * The singlewides still to be produced, by line and by the production week of the cutoff date plus a week
 */
export class SinglewideProduction {

    // The first week is the one that today is in
    @JsonProperty({ toClass: ProductionWeek, designType: 'array' })
    public weeks : ProductionWeek[] = [];

    @JsonProperty({ toClass: SinglewideLine, designType: 'array' })
    public lines : SinglewideLine[] = [];

}
